/**
 * @generated SignedSource<<b72d9e13fc53f27902d49e6400b151bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BasicMetadata = {
  description?: string | null | undefined;
  title: string;
};
export type AclItem = {
  actions: ReadonlyArray<string>;
  role: string;
};
export type CreateSeriesMutation$variables = {
  acl: ReadonlyArray<AclItem>;
  creator: string;
  metadata: BasicMetadata;
};
export type CreateSeriesMutation$data = {
  readonly createSeries: {
    readonly id: string;
  };
};
export type CreateSeriesMutation = {
  response: CreateSeriesMutation$data;
  variables: CreateSeriesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "acl"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "creator"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metadata"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "acl",
        "variableName": "acl"
      },
      {
        "kind": "Variable",
        "name": "creator",
        "variableName": "creator"
      },
      {
        "kind": "Variable",
        "name": "metadata",
        "variableName": "metadata"
      }
    ],
    "concreteType": "Series",
    "kind": "LinkedField",
    "name": "createSeries",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSeriesMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateSeriesMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "9774586780780cb6c68e0cb0fd3ec964",
    "id": null,
    "metadata": {},
    "name": "CreateSeriesMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSeriesMutation(\n  $metadata: BasicMetadata!\n  $acl: [AclItem!]!\n  $creator: String!\n) {\n  createSeries(metadata: $metadata, acl: $acl, creator: $creator) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e54405d7d9b10b1a2466af376389c3e9";

export default node;
